import React, { useContext } from "react";
import { AppContext } from "../AppContext";
import { Snackbar, SnackbarContent } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import clsx from "clsx";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import CloseIcon from "@material-ui/icons/Close";
import { amber, green } from "@material-ui/core/colors";
import IconButton from "@material-ui/core/IconButton";
import WarningIcon from "@material-ui/icons/Warning";

const AppSnackbar = props => {
  const { state, dispatch } = useContext(AppContext);

  const handleClose = () => {
    dispatch({
      type: "SET_SNACKBAR",
      snackbar: { isOpen: false, message: null, variant: "info" }
    });
  };

  const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon
  };

  const useStyles = makeStyles(theme => ({
    success: {
      backgroundColor: green[600]
    },
    error: {
      backgroundColor: theme.palette.error.dark
    },
    info: {
      backgroundColor: theme.palette.primary.main
    },
    warning: {
      backgroundColor: amber[700]
    },
    icon: {
      fontSize: 20
    },
    iconVariant: {
      opacity: 0.9,
      marginRight: theme.spacing(1)
    },
    message: {
      display: "flex",
      alignItems: "center",
      whiteSpace: "pre-line"
    }
  }));

  function SnackbarContentWrapper(props) {
    const classes = useStyles();
    const { className, message, onClose, variant, ...other } = props;
    const Icon = variantIcon[variant];

    return (
      <SnackbarContent
        className={clsx(classes[variant], className)}
        aria-describedby="app-snackbar"
        message={
          <span id="app-snackbar" className={classes.message}>
            <Icon className={clsx(classes.icon, classes.iconVariant)} />
            {message}
          </span>
        }
        action={[
          <IconButton
            key="close"
            aria-label="close"
            color="inherit"
            onClick={onClose}
          >
            <CloseIcon className={classes.icon} />
          </IconButton>
        ]}
        {...other}
      />
    );
  }

  SnackbarContentWrapper.propTypes = {
    className: PropTypes.string,
    message: PropTypes.string,
    onClose: PropTypes.func,
    variant: PropTypes.oneOf(["error", "info", "success", "warning"]).isRequired
  };

  return (
    state.snackbar.message && (
      <Snackbar
        open={state.snackbar.isOpen}
        onClose={handleClose}
        autoHideDuration={7000}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
      >
        <SnackbarContentWrapper
          onClose={handleClose}
          variant={state.snackbar.variant}
          message={state.snackbar.message}
        />
      </Snackbar>
    )
  );
};

export default AppSnackbar;
